<template>
  <div>
    <main class="main">
      <div class="bredcumb">
        <div class="container">
          <ul>
            <li><router-link to="/index">首頁</router-link></li>
            <li>序號錯誤頁面</li>
          </ul>
        </div>
      </div>

      <div class="container">
        <h1>序號錯誤頁面</h1>
      </div>
    </main>
  </div>
</template>

<script>

export default {
  name: 'async',
  metaInfo () {
    return {

      title: '訊息 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '訊息 | 一刻鯨選' },
        { property: 'og:site_name', content: '訊息 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！' }

      ]
    }
  },

  data () {
    return {
      classData: []
    }
  },
  computed: {

  },
  methods: {

  },
  created () {

  },
  mounted () {

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/ErrorCoupon.vue